import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Guid } from 'guid-typescript';
import { AuditModel } from '../models/audit.model';
import { Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';

const VarName = '_config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly urlLog: string = 'IngresarLog';
  private readonly urlImagen: string = 'GetImagen';
  url!: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) {
    this.url = baseUrl + 'api/main/';
  }

  private get urlEscribirLog() {
    return this.url + this.urlLog;
  }

  private get urlGetImagen() {
    return this.url + this.urlImagen;
  }

  fromBinary(binary: any) {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    // Asegurar que la longitud del buffer sea un múltiplo de 2
    let bufferLength = bytes.byteLength;
    if (bufferLength % 2 !== 0) {
      bufferLength++; // Añadir un byte extra si es necesario
    }

    // Crear un nuevo Uint8Array con una longitud múltiplo de 2
    const paddedBytes = new Uint8Array(bufferLength);
    paddedBytes.set(bytes);

    const charCodes = new Uint16Array(paddedBytes.buffer);
    let result = '';
    for (let i = 0; i < charCodes.length; i++) {
      result += String.fromCharCode(charCodes[i]);
    }
    return result;
  }

  getAll() {
    const guardado = localStorage.getItem(VarName);

    console.log("guardado", guardado);
    if (guardado) {
      try {
        const decoded = atob(guardado);
        const original = this.fromBinary(decoded);
        return JSON.parse(original);
      } catch (error) {
        console.error('Error decoding data:', error);
        // Handle the error gracefully (e.g., return an empty array)
        return [];
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  getValue(parametro: string) {
    // const b = this.getAll();
    // const resutl = b.find(
    //   a => a.Parametro === parametro
    // );
    // return resutl?.Valor;
    var valueEncrypt = window.localStorage.getItem(parametro);
    if (valueEncrypt == null || valueEncrypt == undefined) {
      this.router.navigate(['/']);
      return;
    }

    let valueBinary = atob(valueEncrypt);
    let valueJSON = this.fromBinary(valueBinary);
    let value = JSON.parse(valueJSON);
    return value;
  }

  escribirLog(mensaje: string) {
    const endpointUrl = `${this.urlEscribirLog}`;
    return this.http.post<any>(endpointUrl, { mensaje: mensaje });
  }

  getImagenBienvenida() {
    const endpointUrl = `${this.urlGetImagen}`;
    return this.http.get<any>(endpointUrl);
  }

  getVarName() {
    return VarName;
  }
}
